const navbar = require('./navbar')
const eprocMain = require('./eproc.main')
import menu from '#eproc/menu'
import hint from '#eproc/hint'
import toast from '#eproc/toast'
import modal from '#eproc/modal.js'
import ajax from './eproc/ajax.js'

const acessibility = require('./acessibilidade.js')

export default {
    ajax: ajax,
    hint: hint,
    main: eprocMain,
    menu: menu,
    modal: modal,
    navbar: navbar,
    tabs: require('./eproc/tabs'),
    toast: toast,
    init: () => {
        navbar.init()
        eprocMain.init()
        menu.init()
        acessibility.init()
    },
}